const SYSTEM_MAINTENANCE_NOTICE = {
  id: 'weekend-system-maintenance-2026-10',
  startsAt: '2026-10-02T00:00:00-07:00',
  endsAt: '2026-10-05T00:00:00-07:00',
  title: 'Weekend System Maintenance',
  highlight: 'response times for calls, texts, chats, and emails may be longer than usual',
  message: "We're upgrading our systems this weekend, so response times for calls, texts, chats, and emails may be longer than usual. Thank you for your patience."
};

export { SYSTEM_MAINTENANCE_NOTICE };
